(() => {
  if (!customElements.get('fm-sock-pairing')) customElements.define('fm-sock-pairing', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.form = document.getElementById(this.dataset.productForm);
      this.scope = this.closest('product-info') || this.form;
      this.prices = JSON.parse(this.querySelector('[data-fm-variant-prices]').textContent);
      this.choice = this.querySelector('[data-fm-sock-choice]');
      this.choice.disabled = false;
      this.sync = () => {
        const variant = this.form?.querySelector('[name="id"]')?.value;
        const quantity = Math.max(1, Number(new FormData(this.form).get('quantity')) || 1);
        const price = this.prices[variant];
        const addon = Number(this.choice.selectedOptions[0]?.dataset.price || 0);
        this.querySelector('[data-fm-pair-note]').hidden = !this.choice.value;
        this.querySelector('[data-fm-selection-total]').textContent = price === undefined ? '—' : new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency}).format((price * quantity + addon) / 100);
      };
      this.onChange = () => queueMicrotask(this.sync);
      this.scope?.addEventListener('change', this.onChange);
      this.scope?.addEventListener('input', this.onChange);
      this.sync();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onChange);
      this.scope?.removeEventListener('input', this.onChange);
      this.bound = false;
    }
  });
  if (!customElements.get('fm-cart-socks')) customElements.define('fm-cart-socks', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('[data-fm-cart-sock-add]').disabled = false;
      this.querySelector('[data-fm-cart-sock-variant]').disabled = false;
      this.querySelector('[data-fm-cart-sock-add]').addEventListener('click', () => this.add());
    }
    async add() {
      if (this.busy) return;
      this.busy = true;
      const button = this.querySelector('[data-fm-cart-sock-add]');
      const choice = this.querySelector('[data-fm-cart-sock-variant]');
      const status = this.querySelector('[data-fm-cart-sock-status]');
      button.disabled = true; choice.disabled = true;
      status.textContent = status.dataset.adding;
      let added = false;
      try {
        const drawer = document.querySelector('cart-drawer');
        const ids = drawer?.getSectionsToRender?.().map(section => section.id) || ['cart-icon-bubble'];
        const response = await fetch(this.dataset.addUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:choice.value,quantity:1}],sections:ids,sections_url:window.location.pathname})});
        const data = await response.json();
        if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : status.dataset.error);
        added = true;
        status.textContent = status.dataset.added;
        if (this.dataset.placement === 'page') { window.location.assign(this.dataset.cartUrl); return; }
        if (drawer && ids.every(id => data.sections?.[id])) {
          drawer.setActiveElement?.(document.querySelector('#cart-icon-bubble'));
          drawer.renderContents(data);
          drawer.classList.remove('is-empty');
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'fm-cart-socks',cartData:data});
        } else window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        if (added) { window.location.assign(this.dataset.cartUrl); return; }
        status.textContent = error.message || status.dataset.error;
      } finally {
        if (!added) { this.busy = false; button.disabled = false; choice.disabled = false; }
      }
    }
  });
})();
